<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-12">
                <div class="form-group">
                    <label for="itemname">Creditor</label>
                    <select
                        v-model="selectedCreditorId"
                        id="creditbureau"
                        name="creditbureau"
                        type="text"
                        class="form-control"
                        :class="{'is-invalid' : creditorError}"
                        required
                    >
                        <option v-for="creditor in creditors" v-bind:value="creditor.id">{{ creditor.creditor_name }}</option>
                    </select>
                    <span v-if="creditorError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-9 col-md-9 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      ref="inquiry-table"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="selectedCreditorId" hidden>
                                <div id="editor">
                                </div>
                                <div ref="editorRefSingle" hidden>
                                    <div class="page">
                                        <p>
                                            Federal Trade Commission
                                            <br />
                                            Consumer Response Center
                                            <br />
                                            600 Pennsylvania Ave. NW
                                            <br />
                                            Washington, DC 20580
                                            <br />
                                            <br />
                                            Date: {{ date }}
                                            <br />
                                            <br />
                                            To Whom It May Concern:
                                        </p>
                                        <p>
                                            This letter is a formal complaint against <strong>{{ selectedCreditor.creditor_name }}</strong>, a collection agency located at <strong>{{ selectedCreditor.address_line }} {{ selectedCreditor.city }}, {{ selectedCreditor.state }} {{ selectedCreditor.zipcode }}</strong>. They have repeatedly violated my rights per the Fair Debt Collection Practices Act and I'm just over my head with this company. I can't take any more of the stress from fooling with this company and them reporting inaccurate and unverifiable derogatory information about me to the Credit Reporting Agencies.
                                        </p>
                                        <p>
                                            First of all, they have refused to validate the debts they claim I owe their company “Per the FDCPA”. Well I don’t owe their company ANYTHING and that’s why they can’t validate these debts.
                                            <br />
                                            <br />
                                            Secondly, even after debt validation had been requested from them, they deliberately continued collection activity and have electronically verified this debt to the Credit Reporting Agencies, without having validated the dispute with me first, and have since continued to report these accounts to the bureaus. This is a direct violation of the FDCPA and is 100% unacceptable.
                                        </p>
                                        <p>
                                            Furthermore, I’m aware of the many other complaints against this company for their illegal and unethical collection activity. So this really must be addressed and resolved. My next step is to bring media attention to this issue and also to take this matter to court if I have to.
                                        </p>
                                        <p>
                                            Please investigate the collection practices of this company, specifically in my particular case. I'm requesting that this company is disciplined accordingly for their willful and blatant disregard for the law and also that they remove any and all record regarding my name from their database. I would like to prevent other consumers from having to deal with such a heartless and non-compliant company. And in the meantime, would you please also force this company to delete any inaccurate and defaming accounts they are posting about me with the three major credit bureaus since they have failed to validate these accounts. This is causing serious harm not only to my ability to establish credit and good interest rates, but also to my character as a Professional.
                                        </p>
                                        <p>
                                            I have complete records of all correspondences, certified receipts, etc. with this company. If you would like to review this documentation, please let me know. In the meantime, I thank you, in advance, for your immediate attention and response to this matter.
                                        </p>
                                        <p>
                                            Sincerely,
                                            <br />
                                            <br />
                                            {{ userInfo.firstname }} {{ userInfo.lastname }}
                                            <br />
                                            {{ userInfo.address }}
                                            <br />
                                            {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                                            <br />
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <button class="btn btn-primary m-1" type="submit">Create Letter</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed } from 'vue'
  import { ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        routes: {
            type: [Array, Object]
        },
        csrf: {
            type: String
        },
        propCreditors: {
            type: [Array, Object]
        },
        propUserInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        const selectedCreditorId = ref(props.propCreditors[0].id);
        const editorRefSingle = ref(null);
        const isInputFormActive = ref(true),
            creditorError = ref(false),
            date = ref(null);
        return {
            creditors: props.propCreditors,
            userInfo: props.propUserInfo,
            selectedCreditorId,
            editorRefSingle,
            isInputFormActive,
            creditorError,
            date,
            localizationStore: useLocalizationStore()
        };
    },
    data(){
        const disputedCreditor = reactive([]);
        return {
          columns: [
            {
              label: 'CREDITOR',
              field: 'furnisher_name',
            },
            {
              label: 'ACCOUNT NUMBER',
              field: 'account_number',
            },
            {
              label: 'PAYMENT STATUS',
              field: 'payment_status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          disputedCreditor
        };
    },
    created() {
        // console.log(this.creditors);
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditorList();
    },
    computed: {
        // a computed getter
        selectedCreditor() {
            return this.creditors.find((attribute) => {
                if (attribute.id == this.selectedCreditorId) {
                    return attribute;
                }
            })
        }
    },
    methods: {
      dispute: function (id) {
        this.disputedCreditor = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        setTimeout(() => {
            tinymce.activeEditor.setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditorId == null || this.selectedCreditorId == "null") {
            this.creditorError = true;
        }
        else {
            this.creditorError = false;
        }
        return !this.creditorError;
      },
      getCreditorList: function () {
        axios.get(this.routes.creditorListUrl).then(response => {
                this.rows = response.data.data
            }
        );
      }
    }
  };
</script>